import { Box, Flex } from '@pancakeswap/uikit'
import Footer from '@pancakeswap/uikit/src/widgets/Menu/components/Footer'
import { PageMeta } from 'components/Layout/Page'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { isSupportedChain } from 'config/constants/chains'
import dynamic from 'next/dynamic'

const WrongNetworkCard = dynamic(() => import('components/WrongNetwork/WrongNetwork'), { ssr: true })

// Hamburger Menu, Tables, Loader when navigating to new page, page masthead
//earn on chain, swap onchain, farm onchain,

const StyledPage = styled(Flex)`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  padding-bottom: 0rem;
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
  overflow-y: scroll;
  background: radial-gradient(at left top, rgba(10, 29, 86, 0.25) 0%, transparent 30%),
    radial-gradient(at 50% 0%, rgba(10, 29, 86, 0.25) 0%, transparent 20%),
    radial-gradient(at 10% 95%, rgba(10, 29, 86, 0.25) 0%, transparent 20%),
    radial-gradient(at 90% 95%, rgba(10, 29, 86, 0.25) 0%, transparent 20%), linear-gradient(81.62deg, #0a0c16, #06080f) !important;
  border: 0px solid;

  @media (min-width: 1000px) {
    padding: 24px;
    z-index: 25;
  }
`
interface PageProps {
  children: React.ReactNode
  hideFooterOnDesktop?: boolean
  backgroundImageSrc?: string
  backgroundDefaultOpacity?: number
  backgroundDesktopOpacity?: number
}

const Page: React.FC<PageProps> = ({
  children,
  hideFooterOnDesktop = false,
  backgroundImageSrc = '/images/vikings/clean/1.webp',
  backgroundDefaultOpacity,
  backgroundDesktopOpacity,
  ...props
}) => {
  const { chainId } = useActiveWeb3React()
  const [showWrongNetworkCard, setShowWrongNetworkCard] = useState(true)
  const onDismiss = () => {
    setShowWrongNetworkCard(false)
  }

  useEffect(() => {
    setShowWrongNetworkCard(!isSupportedChain(chainId))
  }, [chainId])
  return (
    <>
      <PageMeta />
      <StyledPage {...props}>
        {showWrongNetworkCard ? (
          <WrongNetworkCard onDismiss={onDismiss} />
        ) : (
          <>
            {children}
            <Flex flexGrow={1} />
            {!hideFooterOnDesktop && (
              <Box display={['block', null, null, 'block']}>
                <Footer showBorderTop={true} />
              </Box>
            )}
          </>
        )}
      </StyledPage>
    </>
  )
}

export default Page
